import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { withStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';

const CustomButton = withStyles({
    // remove text transform
    root: {
        textTransform: 'none'
    }
})(Button);

const LoadingIndicator = props =>{
 return <CircularProgress size={24} 
        style = {{
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12}}
    />;
};

const PrimaryButton = props => {
    return (
    <CustomButton
        fullWidth={true}
        variant="contained"
        color="primary" 
        disabled={props.loading}
        {...props}
        >
        {props.children}
        {props.loading && <LoadingIndicator />}
    </CustomButton>);
};

const SecondaryButton = props => {
    return (
    <CustomButton
        fullWidth={true}
        variant="outlined"
        color="primary"
        {...props}
        >
        {props.children}
        {props.loading && <LoadingIndicator />}
    </CustomButton>);
};

PrimaryButton.propTypes = {
    loading: PropTypes.bool,
    children: PropTypes.node
};

SecondaryButton.propTypes = {
    loading: PropTypes.bool,
    children: PropTypes.node
};

const BlueButton = styled(Button)({
    width: '143px',
    height: '40px',
    background: '#0071E9',
    color: '#FFFFFF',
    border: '2px solid #0071E9',
    borderRadius: '4px',
    fontFamily: '"canada-type-gibson", "Roboto", "sans-serif"',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    textTransform: 'capitalize',
    '&.Mui-disabled': {
      background: '#F1F4F6',
      color: '#607480',
      border: '2px solid #BBC8D1'
    },
    '&:hover': {
      background: '#005BBD',
      border: '2px solid #005BBD'
    },
    '.theme-dark &': {
      background: '#0071E9',
      color: '#FFFFFF',
      border: '2px solid #0071E9',
      '&:hover': {
        background: '#005BBD',
        border: '2px solid #005BBD'
      },
      '&.Mui-disabled': {
        background: '#2A2A2A',
        color: '#607480',
        border: '2px solid #2A2A2A'
      }
    }
  });

  const MinimalButton = styled(Button)({
    width: '143px',
    height: '40px',
    background: 'transparent',
    color: '#0071E9',
    border: '2px solid #0071E9',
    borderRadius: '4px',
    fontFamily: '"canada-type-gibson", "Roboto", "sans-serif"',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    textTransform: 'capitalize',
    '&:hover': {
      background: 'rgba(0, 113, 233, 0.08)'
    },
    '.theme-dark &': {
      background: 'transparent',
      color: '#0071E9',
      border: '2px solid #0071E9',
      '&:hover': {
        background: 'rgba(0, 113, 233, 0.12)'
      }
    }
  });

export {PrimaryButton, SecondaryButton, LoadingIndicator, BlueButton, MinimalButton};